import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";

export default function RegisterCompany() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    clientName: "",
    description: "",
    contactPerson: "",
    username: "",
    email: "",
    password: "",
    phoneNo: "",
    companyWebsite: ""
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setError("");
    setSuccess("");

    try {
      // ✅ REGISTER COMPANY
      //await API.post("/company/register", form);
      await API.post("/RegisterCompany", form);

      // ✅ LOGIN AFTER REGISTER
      const loginRes = await API.post("/auth/login", {
        //userName: form.email,   // 🔥 IMPORTANT
          email: form.email,
        password: form.password
      });

      const token = loginRes.data.token;
      const user = loginRes.data.user;

      // ✅ STORE TOKEN
      //localStorage.setItem("token", token);
      localStorage.setItem("authToken", token);
      localStorage.setItem("user", JSON.stringify(user));

      setSuccess("Company created & logged in successfully!");

      // ✅ REDIRECT
      navigate("/add-user");

    } catch (err: any) {
      console.error(err);
      setError("Failed to register company");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="max-w-lg w-full bg-white rounded-2xl shadow-lg p-8">

        <h2 className="text-2xl font-semibold text-center mb-6">
          Register Company
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">

          <input name="clientName" placeholder="Client Name"
            value={form.clientName} onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2" />

          <input name="description" placeholder="Description"
            value={form.description} onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2" />

          <input name="contactPerson" placeholder="Contact Person"
            value={form.contactPerson} onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2" />

          <input name="username" placeholder="Super Admin Username"
            value={form.username} onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2" />

          <input name="email" placeholder="Super Admin Email"
            value={form.email} onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2" />

          <input name="password" type="password" placeholder="Super Admin Password"
            value={form.password} onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2" />

          <input name="phoneNo" placeholder="Phone Number"
            value={form.phoneNo} onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2" />

          <input name="companyWebsite" placeholder="Company Website"
            value={form.companyWebsite} onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2" />

          {error && <div className="text-red-600 text-sm">{error}</div>}
          {success && <div className="text-green-600 text-sm">{success}</div>}

          <button className="w-full bg-green-600 text-white py-2 rounded-lg">
            Register Company
          </button>

          <button
            type="button"
            onClick={() => navigate("/login")}
            className="text-sm text-gray-600 hover:underline w-full"
          >
            Back to Login
          </button>

        </form>
      </div>
    </div>
  );
}